import { legacy_createStore as createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import {
  report1Reducer,
  report2Reducer,
  report3Reducer,
  report4Reducer,
  report5Reducer,
} from "./reducer/LeadMarketing2Reducer";
import { loginUsersReducers, usersListReducer } from "./reducer/UserReducer";
import { campaignListReducer } from "./reducer/CampaignReducer";
import { qualifiesListReducer } from "./reducer/QualifiesReducer";
import { branchListReducer } from "./reducer/BranchReducer";

const reducer = combineReducers({
    report1:report1Reducer,
    report2:report2Reducer,
    report3:report3Reducer,
    report4:report4Reducer,
    report5:report5Reducer,
    loginUsers: loginUsersReducers,
    campaignList: campaignListReducer,
    qualifiesList: qualifiesListReducer,
    usersList: usersListReducer,
    branchList: branchListReducer
});

var userInfoFromStorage = localStorage.getItem("_ssat")
  ? localStorage.getItem("_ssat")
  : "";
var exdtFromStorage = localStorage.getItem("_daex")
  ? localStorage.getItem("_daex")
  : "";
var userDetFromStorage = localStorage.getItem("_sset")
  ? JSON.parse(localStorage.getItem("_sset"))
  : "";

var initialState = {
  loginUsers: {
    userInfo: userInfoFromStorage,
    userDet: userDetFromStorage,
    exdt: exdtFromStorage,
  },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
